import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { QuoteToolPreselectedModes } from '@lx/shared/utils';
import { inject } from '@angular/core';
import { LoggerService } from '@lx/shared/logger';
import { HostDataReaderService } from '../host-data-reader';
import { QuoteToolStrategyService } from './strategies';

export abstract class BaseQuoteToolModeService<T> {
  protected navigationCompleted$ = new BehaviorSubject<boolean>(false);
  protected strategies: Partial<Record<QuoteToolPreselectedModes, QuoteToolStrategyService<T>>> | undefined;
  protected loadedData$ = new Subject<void>();
  protected readonly logger = inject(LoggerService);
  protected readonly hostDataReader = inject(HostDataReaderService);

  getStrategy() {
    return this.strategies[this.hostDataReader.getQuoteToolMode()] || this.strategies.default;
  }

  /**
   * Navigate to the step that is needed for the current mode.
   * If everything is ok, it will return true. Otherwise, it will return false.
   */
  abstract navigate(): Observable<boolean>;

  /**
   * Do default navigation, which means, setting preselected mode to default and initiate navigation
   * to default step.
   */
  protected abstract navigateToDefault(): void;

  /**
   * Do navigation to the step that is needed for the current mode.
   */
  protected abstract doNavigation(strategy: QuoteToolStrategyService<T>): void;
}
